export default __webpack_public_path__ + "salads.08ac9027.svg";